import styled from 'styled-components';

export const Container = styled.div``;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  /* The heading moved to the topbar; the row now holds the screen's
     actions alone, and they stay where they were. */
  justify-content: flex-end;
  gap: var(--s3);
`;
export const Div = styled.div``;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
`;
